export type Config = {
	arranUrl: string;
	statsService: string;
};

export const config = {
	arranUrl: process.env.VUE_APP_ARRAN_URL || "https://api.prodia.com",
	statsService: "https://prodia-stats.herokuapp.com"
};
